export default __webpack_public_path__ + "static/5-b81ab4163cc2f2f21048751e72be499d.jpeg";